/* eslint-disable react/prefer-es6-class, react/prefer-stateless-function */
import React from 'react';
import Localization from 'es6/services/localization';
import { NavButton, Navigation } from 'es6/components/apps/navigation';

/**
 * ItemPackages are expected to contain the memory field.
 */
export default React.createClass({
  displayName: 'TokenExpiredScreen',

  propTypes: {
    onReload: React.PropTypes.func.isRequired,
  },

  render() {
    return (
      <div className="screen screen-token-expired">
        <div className="screen-content">
          <p className="message">{Localization.t('token-expired-explanation')}</p>
        </div>

        <Navigation>
          <NavButton align="right" onClick={this.props.onReload} focused focusable>{Localization.t('quit')}</NavButton>
        </Navigation>
      </div>
    );
  },
});
